




import {Component, Prop, Vue} from 'vue-property-decorator';
import MoreComponent from './MoreComponent.vue';

@Component({
  components: {
    MoreComponent,
  },
})
export default class MoreOne extends Vue {
  private moreData = {
    pic: {
      height: '5.7rem',
      src: require('@/assets/images/5-1.png'),
    },
    avatarData: {
      avatar: require('@/assets/images/avatar-1.png'),
      name: '桑葚',
      article: [
        `真是方便的体验。`,
        '一呼即应的感觉，除了交付钥匙之外，其他一切流程基本做到了无感。我个人问题，一直没有装专属桩。当看到加电小哥超人一般的背影' +
        '的时候，我就知道有救了。感谢老总们给的体验机会。这个月，电费不愁啦！优点不再说，各位大拿们说了很多了。至于流程的缺点…主要有' +
        '两点。第一，小区是刷牌照的固定车位，单位是自己的院儿，替代车模式反而会造成不便，加电小哥可能会找不到停车的位置。因此，还是建' +
        '议根据客户的实际情况，再进一步细化方案。第二，为了保障充电速度，加电小哥在加电过程中，是没办法使用车内空调的。这几天北京虽然' +
        '只有三十度，长久下来还是很遭罪的。还是能希望从人性化角度出发，给予相应的制度设计。',
        `一键加电真的是不错的一次体验，给予车主更多的自由，用过忘不掉，谁用谁知道！`,
      ],
    },
    title: '家里没有充电桩  也能随时加电',
    description: `让创始版第279号北京车主@桑椹告诉你，家中没有条件安装专属桩，如何利用 一键加电 畅享纯电生活。`,
  };
}
